/**
 * Shown when a public form link is opened but the business
 * subscription is inactive / trial expired.
 * Form document status is NOT changed.
 */
const FormUnavailable = ({ businessName }) => {
  const name = businessName ? String(businessName) : "This business";

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "1.5rem",
        background: "linear-gradient(to bottom, #f8fafc 0%, #ffffff 40%)",
        fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, sans-serif",
      }}
    >
      <div
        style={{
          maxWidth: 420,
          width: "100%",
          textAlign: "center",
          padding: "2rem 1.5rem",
          border: "1px solid #e5e7eb",
          borderRadius: 12,
          background: "#fff",
        }}
      >
        <p
          style={{
            margin: "0 0 0.5rem",
            fontSize: "0.75rem",
            letterSpacing: "0.06em",
            textTransform: "uppercase",
            color: "#6b7280",
            fontWeight: 600,
          }}
        >
          Unavailable
        </p>
        <h1
          style={{
            margin: "0 0 0.75rem",
            fontSize: "1.35rem",
            fontWeight: 700,
            color: "#111827",
            lineHeight: 1.3,
          }}
        >
          This form is temporarily unavailable
        </h1>
        <p style={{ margin: 0, fontSize: "0.95rem", color: "#6b7280", lineHeight: 1.5 }}>
          {name} is not accepting submissions through this link right now.
          Please try again later or contact them directly.
        </p>
      </div>
    </div>
  );
};

export default FormUnavailable;
